import { authApiBase } from 'root/src/shared/constants/auth'
import { getCookie } from 'root/src/client/util/cookies'
import nextAjax from 'root/src/client/util/nextAjax'

const authApiRequest = (
	path,
	{ queryParams, body, token, method } = {},
) => {
	const tokenMod = token || getCookie('accessToken')
	return nextAjax({
		url: `${authApiBase}${path}`,
		method,
		body,
		queryParams,
		headers: {
			...(tokenMod ? { Authorization: `Bearer ${tokenMod}` } : {}),
		},
	})
}

const authApi = {
	resetPassword: async ({
		password,
		code,
	}) => authApiRequest('/reset-password', {
		method: 'POST',
		body: {
			password,
			code,
		},
	}),
	forgotPassword: async ({
		email,
		redirectUrl,
	}) => authApiRequest('/forgot-password', {
		method: 'POST',
		body: {
			email,
			redirectUrl,
		},
	}),
	changePassword: async ({
		password,
		newPassword,
	}) => authApiRequest('/change-password', {
		method: 'PATCH',
		body: {
			password,
			newPassword,
		},
	}),
	changeEmail: async ({
		email,
		redirectUrl,
		token,
	}) => authApiRequest('/change-email', {
		method: 'PATCH',
		body: {
			email,
			redirectUrl,
		},
		token,
	}),
	refreshToken: async token => authApiRequest('/refresh-token', {
		method: 'POST',
		body: {
			refreshToken: token,
		},
	}),
	signIn: async ({
		email,
		password,
	}) => authApiRequest('/sign-in', {
		method: 'POST',
		body: {
			email,
			password,
		},
	}),
	signUp: async ({
		email,
		password,
		group,
		redirectUrl,
		data,
	}) => authApiRequest('/sign-up', {
		method: 'POST',
		body: {
			email,
			password,
			group,
			redirectUrl,
			data,
		},
	}),
	unlinkAccount: async ({ platform, platformId }) => authApiRequest('/unlink-account', {
		method: 'POST',
		body: {
			platform,
			platformId,
		},
	}),
	setAccountCredentials: async ({ token, password }) => authApiRequest('/set-account-credentials', {
		body: { token, password },
		method: 'POST',
	}),
	createCredentials: ({
		code,
		email,
		password,
		redirectUrl,
	}) => authApiRequest('/credentials', {
		method: 'POST',
		body: {
			code,
			email,
			password,
			redirectUrl,
		},
		queryParams: {
			code,
		},
	}),
}

export default authApi
